import { useHeartbeat } from '@/api/locations/useHeartbeat';
import { CountIndicator } from '@/components/Badges/CountIndicator';

export const WaitingBadge = () => {
  const { eventsWaiting } = useHeartbeat();
  return <CountIndicator count={eventsWaiting} />;
};
